import React from 'react';

/** @type {React.Context<JPEGLSModule>} */
const JPEGLSModuleContext = React.createContext(undefined);

export default JPEGLSModuleContext;
